import apiHelper from "./apiHelper";

export const getAllNews = async () => {
  try {
    const response = await apiHelper.get(`/api/v1/news/read-all-news`);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "news fetched failed");
    } else {
      throw new Error(error.message || "internal server error");
    }
  }
};
export const deleteNews = async (token, _id) => {
  try {
    const response = await apiHelper.delete(
      `/api/v1/News/delete-News/${_id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "delete News failed");
    } else {
      throw new Error(error.message || "internal server error");
    }
  }
};
export const getNewsById = async (token, _id) => {
  try {
    const response = await apiHelper.get(
      `/api/v1/News/get-News/${_id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "fetch News failed");
    } else {
      throw new Error(error.message || "internal server error");
    }
  }
};
export const updateNews = async (token, _id, newData) => {
  try {
    const response = await apiHelper.put(
      `/api/v1/News/update-News/${_id}`,
      newData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "fetch News failed");
    } else {
      throw new Error(error.message || "internal server error");
    }
  }
};
export const postNews = async (token, formData) => {
  try {
    const response = await apiHelper.post(`/api/v1/news/post-news`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Posting News failed");
    } else {
      throw new Error(error.message || "internal server error");
    }
  }
};
//

export const postUrl = async (token, formData) => {
  try {
    const response = await apiHelper.post(`/api/v1/News/get-url`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Posting News failed");
    } else {
      throw new Error(error.message || "internal server error");
    }
  }
};

export const getUrlList = async (token) => {
  try {
    const response = await apiHelper.get(
      `/api/v1/News/get-url-list`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Posting News failed");
    } else {
      throw new Error(error.message || "internal server error");
    }
  }
};

export const getNewById = async (token, _id) => {
  try {
    const response = await apiHelper.get(
      `/api/v1/news/read-news/${_id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "fetch Blog failed");
    } else {
      throw new Error(error.message || "internal server error");
    }
  }
};
